import { Phone, ArrowRight, CheckCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useSite } from "@/context/SiteContext";

const HERO_IMAGE = "/photos/IMG_6866.jpg";

export const HeroSection = () => {
  const { settings } = useSite();
  const phone = settings?.phone || "514-775-5027";

  const scrollTo = (id) => document.querySelector(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section id="accueil" className="relative bg-white" data-testid="hero-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-center py-14 md:py-20">
          <div className="order-2 lg:order-1">
            <div className="inline-flex items-center gap-2 bg-green-50 text-[#2D5A3D] px-3 py-1.5 rounded-full text-sm font-medium mb-5">
              <span className="w-2 h-2 bg-[#2D5A3D] rounded-full"></span>
              Châteauguay · Mercier · Léry
            </div>

            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 leading-tight tracking-tight mb-5" data-testid="hero-title">
              {settings?.hero_title || "Entretien extérieur professionnel pour votre propriété"}
            </h1>

            <p className="text-base lg:text-lg text-gray-600 mb-6 max-w-lg leading-relaxed" data-testid="hero-subtitle">
              {settings?.hero_subtitle || "Tonte de gazon, lavage de vitres, paysagement, entretien de terrain et plus encore. Un service fiable et de qualité."}
            </p>

            <div className="flex items-center gap-x-6 gap-y-2 flex-wrap text-sm text-gray-600 mb-7">
              <span className="flex items-center gap-1.5"><CheckCircle className="w-4 h-4 text-[#2D5A3D]" />Soumission gratuite</span>
              <span className="flex items-center gap-1.5"><CheckCircle className="w-4 h-4 text-[#2D5A3D]" />Service garanti</span>
              <span className="flex items-center gap-1.5"><CheckCircle className="w-4 h-4 text-[#2D5A3D]" />Réponse rapide</span>
            </div>

            <div className="flex flex-col sm:flex-row gap-3">
              <Button onClick={() => scrollTo("#contact")} size="lg" className="bg-[#2D5A3D] hover:bg-[#234A30] text-white px-8 py-3 h-auto text-base" data-testid="hero-cta-button">
                {settings?.hero_cta || "Demander une soumission gratuite"}
                <ArrowRight className="w-4 h-4 ml-1" />
              </Button>
              <a href={`tel:${phone.replace(/-/g, "")}`} className="inline-flex items-center justify-center gap-2 px-6 py-3 border border-[#2D5A3D] text-[#2D5A3D] rounded-md font-medium hover:bg-green-50 transition-colors" data-testid="hero-phone-button">
                <Phone className="w-4 h-4" />{phone}
              </a>
            </div>
          </div>

          <div className="order-1 lg:order-2">
            <div className="relative rounded-xl overflow-hidden shadow-lg aspect-[4/3] bg-gray-100">
              <img 
                src={HERO_IMAGE} 
                alt="Pelouse entretenue professionnellement par Les Entretiens Élites à Châteauguay" 
                className="w-full h-full object-cover"
                width={800}
                height={600}
                decoding="async"
                fetchPriority="high"
                data-testid="hero-image"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='800' height='600'%3E%3Crect fill='%232D5A3D' width='800' height='600'/%3E%3Ctext x='50%25' y='50%25' text-anchor='middle' dy='.3em' fill='white' font-size='24' font-family='sans-serif'%3ELes Entretiens Élites%3C/text%3E%3C/svg%3E";
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
